'use client'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { IHomeBanner } from '@/schemas/pages'
import Banner from '../Banner'

interface ICarouselProps {
    slides: IHomeBanner[]
}

/** Carrossel de banners da home (Swiper, troca a cada 2,5 s). O primeiro banner é a imagem de LCP. */
export const Carousel: React.FC<ICarouselProps> = ({ slides }) => {
    const pagination = {
        clickable: true,
        renderBullet: (index: number, className: string) => {
            const colors = ['bg-primary-green', 'bg-orange', 'bg-primary']
            const color = colors[index % colors.length]
            return `<span class="${className} ${color}"> </span>`
        },
    }
    return (
        <Swiper
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            pagination={pagination}
            navigation={{
                nextEl: '.image-swiper-button-next',
                prevEl: '.image-swiper-button-prev',
            }}
            modules={[Autoplay, Pagination, Navigation]}
            loop={true}
            className="relative flex flex-row items-center justify-center w-full h-full overflow-hidden cursor-grab active:cursor-grabbing "
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={`${slide.order}-${slide.imageDesktop}`}>
                    <Banner slide={slide} isPriority={index === 0} />
                </SwiperSlide>
            ))}
            <div className="swiper-button image-swiper-button-next absolute max-lg:right-[35%] right-[45%] bottom-2.5 z-50">
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
            <div className="swiper-button image-swiper-button-prev absolute max-lg:left-[35%] left-[45%] bottom-2.5 z-50">
                <FontAwesomeIcon icon={faArrowLeft} />
            </div>
        </Swiper>
    )
}
